import { Box } from '@mui/material';
import StatusDot from './StatusDot';

type StatusLineProps = {
    label: string;
    color: string;
    size?: number;
};

/** Status dot plus its label. */
export default function StatusLine({
    label,
    color,
    size = 12,
}: StatusLineProps) {
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: size,
                color: 'text.secondary',
                whiteSpace: 'nowrap',
            }}
        >
            <StatusDot color={color} />
            {label}
        </Box>
    );
}
